import type { AgentSettingsApi } from '@env0/agent-settings-service/api';

export const getAgentDisplayName = (agent: { name?: string | null; agentKey: string } | null | undefined): string =>
  agent?.name ?? agent?.agentKey ?? '';

export const isSaasDefaultAgent = (agents: AgentSettingsApi.ListAgents.Response | undefined): boolean =>
  !!agents?.find(agent => agent.isDefault)?.isSaas;
